export default function initFormInfoIcons(): void {
  const labels = document.querySelectorAll<HTMLElement>(
    '.umbraco-forms-label, .umbraco-forms-legend'
  );

  labels.forEach((label) => {
    const tooltip = label.nextElementSibling as HTMLElement | null;

    if(!tooltip?.classList.contains('umbraco-forms-tooltip') || !tooltip.textContent?.trim()) {
      return;
    }

    const tooltipId = `tooltip-${Math.random().toString(36).slice(2)}`;
    tooltip.id = tooltipId;

    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', tooltipId);

    const icon = document.createElement('i');
    icon.classList.add('xlent-icon-info-circled');
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);
    label.appendChild(button);

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = tooltip.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen.toString());
    });

    tooltip.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.umbraco-forms-tooltip.is-open').forEach((tooltip) => {
      tooltip.classList.remove('is-open');
      const button = document.querySelector<HTMLButtonElement>(`[aria-controls="${tooltip.id}"]`);
      button?.setAttribute('aria-expanded', 'false');
    });
  });
}
